import './OrderSummary.css';
import type { CheckoutParams } from '../../utils/queryParamParser';

function formatAmount(amount: string, currency: string): string {
    const num = parseFloat(amount);
    if (isNaN(num)) return `${currency} ${amount}`;
    return new Intl.NumberFormat('en-CA', {
        style: 'currency',
        currency: currency,
    }).format(num);
}

interface OrderSummaryProps {
    params: CheckoutParams | null;
}

function OrderSummary({ params }: OrderSummaryProps) {
    if (!params) return null;

    const { amount, currency, customerName, customerEmail, orderId } = params;

    return (
        <section className="order-card">
            <h2 className="order-heading">Order Summary</h2>
            <div className="order-rows">
                {customerName && (
                    <div className="order-row">
                        <span className="order-label">Customer</span>
                        <span className="order-value">{customerName}</span>
                    </div>
                )}

                {customerEmail && (
                    <div className="order-row">
                        <span className="order-label">Email</span>
                        <span className="order-value">{customerEmail}</span>
                    </div>
                )}

                <div className="order-row">
                    <span className="order-label">Order ID</span>
                    <span className="order-value">{orderId}</span>
                </div>

                <div className="order-amountRow">
                    <span className="order-amountLabel">Total</span>
                    <span className="order-amountValue">
                        {formatAmount(amount, currency)}
                    </span>
                </div>
            </div>
        </section>
    );
}

export default OrderSummary;
